@if (chatService.moderationFeed()) {
  <div id="moderation-chat-feed" class="chat-feed-wrapper">
    @for (msg of chatService.moderationFeed(); track msg) {
      <div #messageBox class="chat-msg-box">
        @if (isMsgPending(msg.status)) {
          <div class="chat-msg-card">
            <div class="chat-msg-card-actions">
              <div class="chat-msg-action approve" (click)="handleMessageReceived(true, msg)">Publish</div>
              <div class="chat-msg-action dismiss" (click)="handleMessageReceived(false, msg)">Dismiss</div>
            </div>
            <div class="chat-msg-card-reply" (click)="handleReply(msg)">Reply</div>
            <div class="chat-msg-card-body">
              <div class="chat-msg-header">
                <div class="chat-msg-sender">
                  <strong [title]="msg.sender.firstName + ' ' + (msg.sender.lastName || '')">
                    {{ formatUsersName(msg.sender.firstName, msg.sender.lastName) }}
                  </strong>
                </div>
              </div>
              <div class="chat-msg-content" [innerHtml]="msg.message"></div>
              <div class="chat-msg-footer" [title]="msg.sentDate.toString()">
                {{ msg.sentDate | timeDiffAsync | async }}
              </div>
            </div>
          </div>
        } @else {
          <div>
            <div class="chat-msg-header">
              <div class="chat-msg-sender">
                <strong [title]="msg.sender.firstName + ' ' + (msg.sender.lastName || '')">
                  {{ formatUsersName(msg.sender.firstName, msg.sender.lastName) }}
                </strong>
              </div>
            </div>
            <div class="chat-msg-status" [ngClass]="formatStatusClass(msg.status)">
              {{ formatStatusMessage(msg.moderator, msg.status) }}
            </div>
            <div class="chat-msg-content" [innerHtml]="msg.message"></div>
            <div class="chat-msg-footer" [title]="msg.sentDate.toString()">
              {{ msg.sentDate | timeDiffAsync: 5000 | async }}
            </div>
          </div>
        }
        @if (shouldShowError(msg)) {
          <div class="chat-msg-failed">
            Message failed to send. Check network connection and <strong>try again</strong>.
          </div>
        }
      </div>
    }
  </div>
}
